import { Component, inject } from '@angular/core';
import { AnalyticsService } from './core/analytics.service';
import { AuthSessionService } from './core/auth-session.service';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly session = inject(AuthSessionService);
  readonly analytics = inject(AnalyticsService);
  constructor() { this.analytics.start(); }
}
